import { ExperienceType } from '@ninetailed/experience.js-shared';

const VARIANT_NAMES = {
  BASELINE: 'Baseline',
  CONTROL: 'Control',
  VARIANT_PREFIX: 'Variant',
};

const EXPERIENCE_TYPES = {
  EXPERIMENT: 'nt_experiment',
  PERSONALIZATION: 'nt_personalization',
};

/**
 * Determines the appropriate variant name based on experience type and variant data
 * @param variantIndex - The numerical index of the variant
 * @param variantName - The Internal Name of the variant from Contentful
 * @param experienceType - The type of Ninetailed experience (nt_personalization or nt_experiment)
 * @returns The name for the variant for Snowflake
 */
export function getVariantDisplayName(
  variantIndex: number,
  variantName: string,
  experienceType?: ExperienceType | undefined,
): string {
  if (experienceType === EXPERIENCE_TYPES.PERSONALIZATION) {
    return variantName;
  }

  if (experienceType === EXPERIENCE_TYPES.EXPERIMENT) {
    if (variantIndex === 0) {
      return VARIANT_NAMES.CONTROL;
    }
    return `${VARIANT_NAMES.VARIANT_PREFIX} ${variantIndex}`;
  }

  return VARIANT_NAMES.BASELINE;
}
